import { ChangeEvent, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
// Components


// Constants




// Scss
//import '../../../assets/css/partnerProgram.scss';
//import '../../../assets/css/partnerPortal/welcome.scss';

// actions
import * as worldMapTeamAction from "../../actions/teamMap/WorldMapTeamAction";


import WorldMapTeamDTO from "../../models/teamMap/WorldMapTeamDTO";

import { Button, Table } from "react-bootstrap";
import DynatraceContactDTO from "../../models/teamMap/DynatraceContactDTO";
import WorldMapTeam from "./WorldMapTeam";



function WorldMapTeamRegionEdit() {

  let history = useHistory();
  const region = useParams()["region"].toUpperCase();
  const [worldMapTeamDTO, setWorldMapTeamDTO] = useState<Array<WorldMapTeamDTO>>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState<Array<WorldMapTeamDTO>>([]);
  const [error, setError] = useState<string | null>(null);
  const [contacts, setContacts] = useState<Array<DynatraceContactDTO>>([]);
  

  useEffect(() => {
    canYouHaveAccess();
    getMapByRegion();
    getDynatraceContactsByRegion()
  }, []);


  const handleInputChange = (e: ChangeEvent<HTMLInputElement| HTMLSelectElement>, id: number) => {
    const { name, value } = e.target;
    const updatedFormData = formData.map(item => 
      item.id === id ? { ...item, [name]: name === "dynatraceContact" ? contacts.find(c => c.id === Number(value)) : value  } : item
    );
    setFormData(updatedFormData);
  };

  const handleEdit = (index) => {
    setIsEditing(true);
    setError(null);
  };

  const handleSave = () => {
    setIsLoading(true);
    //setWorldMapTeamDTO(formData);
    setIsEditing(false);
    setError(null);
    
    worldMapTeamAction
    .saveUpdateWorldMap(formData)
    .then(c => {
      console.log(c.data);
      setWorldMapTeamDTO(c.data);
      setFormData(c.data);
    })
    .then(c => {
      setIsLoading(false);
    })
    .catch(err => {
      console.error('oops, something went wrong!', err);
      setError("There is an error. Make sure your vpn is on. or try later.");
      setFormData(worldMapTeamDTO);
    });

  };

  const handleCancel = () => {
    setFormData(worldMapTeamDTO);
    setIsEditing(false);
    setError(null);
  };


  return (
    <>
    {isLoading ? <div className="m-4" style={{ color: 'red' }}>{"is Loading..."}</div> :
      <div>
        <h1 className="m-3">Editable Table - {region}</h1>
        <label className="ml-4">
        </label>
        <Button onClick={isEditing ? handleSave : handleEdit} className="mt-3 mb-3">
          {isEditing ? 'Save' : 'Edit'}
        </Button>
        {isEditing && <Button className="btn-danger ml-2"  onClick={handleCancel}>Cancel</Button>}
        <Button className="ml-5 btn-dark" href={'/world-map/edit/' + region}>Edit Team</Button>
        <Button className="ml-2 btn-dark" href={'/world-map/' + region}>See Map</Button>
        {error && <div className="m-4" style={{ color: 'red' }}>{error}</div>}
        <Table className="mb-5">
          <thead>
            <tr>
              <th>Location</th>
              {region === "NORAM" ? <th>Country</th> : null}
              <th>Dynatrace Contact</th>
            </tr>
          </thead>
          <tbody>
            {formData?.map((item, index) => (
              <tr key={item.id}>
              <td>
                  { 
                    item.location || ''
                  }
                </td>
              {region === "NORAM" ? <td>
                {item.country || ''}
              </td> : null}
              <td>
                  {isEditing ? (
                    <select
                      name="dynatraceContact"
                      value={formData[index].dynatraceContact?.id || ''}
                      onChange={(e) => handleInputChange(e, item.id!)}
                    >
                      {contacts.map(contact => (
                        <option key={contact.id} value={contact.id}>
                          {contact.name}
                        </option>
                      ))}
                    </select>
                  ) : (
                    item.dynatraceContact?.name || ''
                  )}
                </td>
            </tr>
          ))}
  
          </tbody>
        </Table>
        <WorldMapTeam isSecondaryScreen={true}></WorldMapTeam>
      </div>
    }
    </>
  );

    function canYouHaveAccess() {
    try {
        if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
        }
    } catch (err) {
        
    }
    };

    async function getMapByRegion() {
      worldMapTeamAction.getMapByRegion(region).then(response => {
        const locations: Array<WorldMapTeamDTO> = response.data;
        setWorldMapTeamDTO(locations);
        setFormData(locations);
      }).catch(err => {
        console.error('oops, something went wrong!', err);
      });
    }

    async function getDynatraceContactsByRegion() {
      worldMapTeamAction.getDynatraceContactsByRegion(region).then(response => {
        const team: Array<DynatraceContactDTO> = response.data.sort((a, b) =>Number(a.position) - Number(b.position));
        setContacts(team);
      }).catch(err => {
        console.error('oops, something went wrong!', err);
      });
    }

}

export default WorldMapTeamRegionEdit;

